<template>
    <b-container>
        <b-card no-body>
            <b-card-header>
                <i class="icon-note"></i>
                <strong>{{
                    $t('form.create', { item: $t('indicators.indicator') })
                }}</strong>
            </b-card-header>
            <b-card-body>
                <Form
                    v-if="permissions.modules.has_kpi"
                    @onSubmit="onSubmit"
                    :isEdit="false"
                    :can-create="true"
                    :moduleForm="'indicator'"
                    :current-event-permissions="
                        permissions.current_event_permissions.goals
                    "
                />
                <div v-else>
                    <b-alert show variant="warning" class="mt-3">
                        <i class="fa fa-warning "></i>
                        {{
                            $t('notification.permissions.createDenied', {
                                item: $t('indicators.indicators'),
                            })
                        }}
                    </b-alert>
                </div>
            </b-card-body>
        </b-card>
    </b-container>
</template>

<script>
import api from '@/services/api'
import i18n from '@/i18n'
import Swal from 'sweetalert2'
import { mapperKpiToApi } from './mappers/mapperKpiToApi'
import notification, { success, danger } from '@/lib/notification'
import { getUserPermissions } from '@/services/user-permissions'
import Form from '@/views/target/components/form'

notification.init()

export default {
    name: 'New',
    components: {
        Form,
    },
    data() {
        return {
            permissions: {},
        }
    },
    created() {
        this.permissions = getUserPermissions()
    },
    mounted() {
        this.isAllowedToCreateKpis()
    },
    methods: {
        isAllowedToCreateKpis() {
            if (!this.permissions.modules.has_kpi) {
                Swal({
                    type: 'warning',
                    title: i18n.t('notification.permissions.createDenied', {
                        item: i18n.t('indicators.indicators'),
                    }),
                })
            }
        },
        goBack() {
            this.$router.back()
        },
        onSubmit(form, onReset, isLoading) {
            isLoading(true)
            api.post('/kpi', mapperKpiToApi(form))
                .then(() => {
                    onReset()
                    this.notificationIndicatorCreatedSuccessfully()
                    this.goBack()
                })
                .catch(e => {
                    console.log(e)
                    this.notificationError()
                })
                .finally(() => {
                    isLoading(false)
                })
        },
        notificationIndicatorCreatedSuccessfully() {
            success(
                i18n.t('notification.createdSuccessfully', {
                    item: i18n.t('indicators.indicator'),
                })
            )
        },
        notificationError() {
            danger()
        },
    },
}
</script>
